import { useCallback, useEffect, useState } from "react";
import { getFrameRect } from "./frameGeometry";

/**
 * Следит за размером контейнера и метаданными видео и отдаёт прямоугольник кадра (px, относительно контейнера).
 * videoEl и containerEl — DOM-элементы (могут быть null, пока не смонтированы).
 */
export default function useFrameRect(videoEl, containerEl) {
  const [rect, setRect] = useState(null);

  const update = useCallback(() => {
    setRect((prev) => {
      const next = getFrameRect(videoEl, containerEl);
      if (!next) return prev;
      if (
        prev &&
        Math.abs(prev.left - next.left) < 0.5 &&
        Math.abs(prev.top - next.top) < 0.5 &&
        Math.abs(prev.width - next.width) < 0.5 &&
        Math.abs(prev.height - next.height) < 0.5
      ) {
        return prev;
      }
      return next;
    });
  }, [videoEl, containerEl]);

  useEffect(() => {
    if (!videoEl || !containerEl) return undefined;
    update();
    const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(update) : null;
    if (ro) {
      ro.observe(containerEl);
      ro.observe(videoEl);
    }
    videoEl.addEventListener("loadedmetadata", update);
    videoEl.addEventListener("resize", update);
    window.addEventListener("resize", update);
    document.addEventListener("fullscreenchange", update);
    document.addEventListener("webkitfullscreenchange", update);
    return () => {
      if (ro) ro.disconnect();
      videoEl.removeEventListener("loadedmetadata", update);
      videoEl.removeEventListener("resize", update);
      window.removeEventListener("resize", update);
      document.removeEventListener("fullscreenchange", update);
      document.removeEventListener("webkitfullscreenchange", update);
    };
  }, [videoEl, containerEl, update]);

  return rect;
}
